import { FeedbackRating } from '../../hooks/useFeedbackReducer/constants';
import { UnreachableCaseError } from '../../errors/UnreachableCaseError';
import { FEEDBACK_MODAL_REDESIGN_GENERAL_FEEDBACK, FEEDBACK_MODAL_REDESIGN_OPT_OUT, FEEDBACK_MODAL_REDESIGN_TRELLIS_FEEDBACK, FeedbackStepTypes } from './constants';
const isQa = window.location.host.indexOf('hubspotqa') > -1;
const surveyType = 'CSAT';
const surveyPortal = isQa ? '100765651' : '53';
export const feedbackModalConfig = {
  [FEEDBACK_MODAL_REDESIGN_OPT_OUT]: {
    survey: {
      portal: surveyPortal,
      type: surveyType,
      id: isQa ? '183' : '572'
    },
    steps: [{
      type: FeedbackStepTypes.rating,
      headerKey: 'nav.feedbackModal.surveyQuestion.satisfaction'
    }, {
      type: FeedbackStepTypes.feedback,
      getHeaderKey: rating => {
        switch (rating) {
          case FeedbackRating.UNHAPPY:
            return 'nav.feedbackModal.surveyQuestion.sad';
          case FeedbackRating.NEUTRAL:
            return 'nav.feedbackModal.surveyQuestion.neutral';
          case FeedbackRating.HAPPY:
            return 'nav.feedbackModal.surveyQuestion.happy';
          default:
            throw new UnreachableCaseError(rating);
        }
      },
      consentTextKey: 'nav.feedbackModal.consensus'
    }, {
      type: FeedbackStepTypes.complete
    }]
  },
  [FEEDBACK_MODAL_REDESIGN_GENERAL_FEEDBACK]: {
    survey: {
      portal: surveyPortal,
      type: surveyType,
      id: isQa ? '409' : '1120'
    },
    steps: [{
      type: FeedbackStepTypes.rating,
      headerKey: 'nav.feedbackModal.generalSurveyQuestion.satisfaction'
    }, {
      type: FeedbackStepTypes.feedback,
      getHeaderKey: rating => {
        switch (rating) {
          case FeedbackRating.UNHAPPY:
            return 'nav.feedbackModal.generalSurveyQuestion.sad';
          case FeedbackRating.NEUTRAL:
            return 'nav.feedbackModal.generalSurveyQuestion.neutral';
          case FeedbackRating.HAPPY:
            return 'nav.feedbackModal.generalSurveyQuestion.happy';
          default:
            throw new UnreachableCaseError(rating);
        }
      },
      consentTextKey: 'nav.feedbackModal.generalConsensus'
    }, {
      type: FeedbackStepTypes.complete
    }]
  },
  [FEEDBACK_MODAL_REDESIGN_TRELLIS_FEEDBACK]: {
    survey: {
      portal: surveyPortal,
      type: surveyType,
      id: isQa ? '521' : '1345'
    },
    steps: [{
      type: FeedbackStepTypes.rating,
      headerKey: 'nav.trellis.feedback.lookAndFeel'
    }, {
      type: FeedbackStepTypes.feedback,
      getHeaderKey: rating => {
        switch (rating) {
          case FeedbackRating.UNHAPPY:
            return 'nav.trellis.feedback.tellUsMore';
          case FeedbackRating.NEUTRAL:
            return 'nav.trellis.feedback.tellUsMore';
          case FeedbackRating.HAPPY:
            return 'nav.trellis.feedback.tellUsMore';
          default:
            throw new UnreachableCaseError(rating);
        }
      },
      consentTextKey: 'nav.trellis.feedback.consent'
    }, {
      hideIllustration: true,
      type: FeedbackStepTypes.complete
    }]
  }
};